module.exports = __webpack_public_path__ + "img/out-for-signature.da586dd1.svg";